// extracted by mini-css-extract-plugin
module.exports = {"noScrollX":"Utils_noScrollX__1ce1E","noScrollY":"Utils_noScrollY__3R_oD"};